export const STANDARD_IMAGE_PATH = '';
